import i18n from "../../i18n"

export const IncidentManagementEfficiencySummary = i18n.t('analytics.IncidentManagementEfficiencySummary');
export const Filters = i18n.t('manageAutomation.filters');
export const AutomationBusinessFilters = i18n.t('manageAutomation.ABfilters');
export const home = i18n.t('analytics.home')
export const Analytics = i18n.t('analytics.Analytics')
export const IAmA = i18n.t('analytics.IAmA')
export const Supervisor = i18n.t('analytics.Supervisor')
export const Process = i18n.t('analytics.Process')
export const Owner = i18n.t('analytics.Owner')
export const Automation = i18n.t('analytics.Automation')
export const CoE = i18n.t('analytics.CoE')
export const ShowingStatsFor = i18n.t('analytics.ShowingStatsFor')
export const NoDataAvailable = i18n.t('analytics.NoDataAvailable')
export const Loading = i18n.t('analytics.Loading')
export const Group = i18n.t('analytics.Group')
export const labels = i18n.t('analytics.labels')
export const Date = i18n.t('analytics.Date')
export const Value = i18n.t('analytics.Value')
export const key = i18n.t('analytics.key')
export const DataTable = i18n.t('analytics.DataTable')
export const group = i18n.t('analytics.group')
export const Previouspage = i18n.t('analytics.Previouspage')
export const NextPage = i18n.t('analytics.NextPage')
export const Itemspage = i18n.t('analytics.Itemspage')
export const Export = i18n.t('analytics.Export')
export const Priority = i18n.t('analytics.Priority')
export const Download = i18n.t('analytics.Download')
export const franchise = i18n.t('filter.franchise');
export const Client = i18n.t('filter.Client');
export const Assignee = i18n.t('filter.Assignee');
export const Technology = i18n.t('filter.Technology');
export const DeploymentModel = i18n.t('filter.DeploymentModel');
export const Geo = i18n.t('filter.Geo');
export const Competency = i18n.t('filter.Competency');
export const FilterPriority = i18n.t('filter.FilterPriority')
export const JobId = i18n.t('filter.JobId');
export const Status = i18n.t('filter.Status');
export const FilterIncidentStatus = i18n.t('filter.IncidentStatus');
export const QueueName = i18n.t('filter.QueueName');
export const AutomataState = i18n.t('filter.AutomataState');
export const AssignedGroup = i18n.t('filter.AssignedGroup');
export const AssigneeEmail = i18n.t('filter.AssigneeEmail');
export const AssignmentGp = i18n.t('filter.AssignmentGp');
export const AutomataName = i18n.t('filter.AutomataName');
export const AutomataActivityName = i18n.t('filter.AutomataActivityName');
export const BusinessComponent = i18n.t('filter.BusinessComponent');
export const ItemStatusA1 = i18n.t('filter.ItemStatusA1');
export const Resource = i18n.t('filter.Resource');
export const BotID = i18n.t('filter.BotId');
export const SuggestedRemediation = i18n.t('manageAutomation.SuggestedRemediation');
export const CleanUpAndReRun = i18n.t('manageAutomation.CleanUpAndReRun');
export const Run = i18n.t('manageAutomation.Run');
export const RerunSchedule = i18n.t('manageAutomation.RerunSchedule');
export const RestartResource = i18n.t('manageAutomation.RestartResource');
export const RerunProcess = i18n.t('manageAutomation.RerunProcess');
export const BotName = i18n.t('filter.BotName');
export const loading = i18n.t('analytics.loading');
export const LineChartTooltip = i18n.t('analytics.LineChartTooltip');
export const AlertSource = i18n.t('filter.AlertSource');
export const SystemName = i18n.t('filter.SystemName');

//Homepage
export const FTESaving = i18n.t('homepage.FTESaving');
export const NoOfOnboardedAutomata = i18n.t('homepage.NoOfOnboardedAutomata');
export const IncidentConversionRatioKpi = i18n.t('homepage.IncidentConversionRatioKpi');
export const EliminatedNoiseKpi = i18n.t('homepage.EliminatedNoiseKpi');
export const TotalAlertsCount = i18n.t('homepage.TotalAlertsCount');
export const DuplicateAlertsCount = i18n.t('homepage.DuplicateAlertsCount');
export const InformationalAlertsCount = i18n.t('homepage.InformationalAlertsCount');
export const TicketsCreatedCount = i18n.t('homepage.TicketsCreatedCount');
export const QueueAverageHandling = i18n.t('homepage.QueueAverageHandling');
export const FirsttimeResolution = i18n.t('homepage.FirsttimeResolution');
export const AlertVsIncidentTrend = i18n.t('homepage.AlertVsIncidentTrend');
export const IncidentConversionRatioNoiseReduction = i18n.t('homepage.IncidentConversionRatioNoiseReduction');
export const AlertClassification = i18n.t('homepage.AlertClassification');
export const SuccessAndTerminationTrend = i18n.t('homepage.SuccessAndTerminationTrend');
export const RsourceLiveStatus = i18n.t('homepage.RsourceLiveStatus');
export const SelfHeal = i18n.t('homepage.SelfHeal');
export const QueueStatistics = i18n.t('homepage.QueueStatistics');
export const TopLongRunningAutomtaList = i18n.t('homepage.TopLongRunningAutomtaList');
export const ExceptionClassification = i18n.t('homepage.ExceptionClassification');
export const AutomationStartsOnTimeTrend = i18n.t('homepage.AutomationStartsOnTimeTrend');
export const AutomationRunsOnTimeTrend = i18n.t('homepage.AutomationRunsOnTimeTrend');
export const TopTerminationReasons = i18n.t('homepage.TopTerminationReasons');
export const FirstTimeSuccessfulRun = i18n.t('homepage.FirstTimeSuccessfulRun');
export const AddRemoveKPIs = i18n.t('homepage.AddRemoveKPIs');
export const IncidentManagementKPIs = i18n.t('homepage.IncidentManagementKPIs');
export const AlertManagementKPIs = i18n.t('homepage.AlertManagementKPIs');
export const AutomataManagementKPIs = i18n.t('homepage.AutomataManagementKPIs');
export const ManageKPIs = i18n.t('homepage.ManageKPIs');
export const UserLoginTopfailures = i18n.t('homepage.UserLoginTopfailures');
export const BatchJobFailures = i18n.t('homepage.BatchJobFailures');
export const IntegrationTopFailures = i18n.t('homepage.IntegrationTopFailures');
export const AbandonedProcessesFailures = i18n.t('homepage.AbandonedProcessesFailures');


//DashboardNames
export const ProductivityMetrics = i18n.t('analytics.ProductivityMetrics');
export const Remediation = i18n.t('analytics.Remediation');
export const BusinessViewValueRealization = i18n.t('analytics.BusinessViewValueRealization');
export const Juniper = i18n.t('analytics.Juniper');
export const IncidentManagementEfficiency = i18n.t('analytics.IncidentManagementEfficiency');
export const SchedulingEfficiency = i18n.t('analytics.SchedulingEfficiency');
export const QueueManagement = i18n.t('analytics.QueueManagement');
export const AutomationTrustIndex = i18n.t('analytics.AutomationTrustIndex');
export const SLACompliance = i18n.t('analytics.SLACompliance')
export const AlertManagement = i18n.t('analytics.AlertManagement');
export const CapacityManagement = i18n.t('analytics.CapacityManagement');
export const ExecutionPerformance = i18n.t('analytics.ExecutionPerformance');
export const BotPerformance = i18n.t('analytics.BotPerformance');
export const QueueEfficiency = i18n.t('analytics.QueueEfficiency');
export const Bpmn = i18n.t('analytics.Bpmn');
export const FinanceReporting = i18n.t('analytics.FinanceReporting');
export const UserLoginStatistics = i18n.t('analytics.UserLoginStatistics');
export const BatchJobStatistics = i18n.t('analytics.BatchJobStatistics');
export const IntegrationStatistics = i18n.t('analytics.IntegrationStatistics');
export const AbandonedProcesses = i18n.t('analytics.AbandonedProcesses');
export const UsageStats = i18n.t('analytics.UsageStats');

//Incident Management
export const IncidentAgeing = i18n.t('analytics.IncidentAgeing')
export const ReopenCount = i18n.t('analytics.ReopenCount')
export const FirstTimeResolved = i18n.t('analytics.FirstTimeResolved')
export const DetailedView = i18n.t('analytics.DetailedView')
export const PerformanceTrendTicketData = i18n.t('analytics.PerformanceTrendTicketData')
export const TotalTicketsCount = i18n.t('analytics.TotalTicketsCount')
export const Time = i18n.t('analytics.Time')
export const TimePeriod = i18n.t('analytics.TimePeriod')
export const Total = i18n.t('analytics.Total')
export const New = i18n.t('analytics.New')
export const InProgress = i18n.t('analytics.InProgress')
export const Cancelled = i18n.t('analytics.Cancelled')
export const OnHold = i18n.t('analytics.OnHold')
export const Resolved = i18n.t('analytics.Resolved')
export const Closed = i18n.t('analytics.Closed')
export const IncidentAgeingSLAReport = i18n.t('analytics.IncidentAgeingSLAReport')
export const FirstTimeResolution = i18n.t('analytics.FirstTimeResolution')
export const AvgIncidentAgeing = i18n.t('analytics.AvgIncidentAgeing')
export const Franchise = i18n.t('analytics.Franchise')
export const TotalTickets = i18n.t('analytics.TotalTickets')
export const AvgAging = i18n.t('analytics.AvgAging')
export const FirstTimeResolve = i18n.t('analytics.FirstTimeResolve')
export const SeverityWiseIncidentStatus = i18n.t('analytics.SeverityWiseIncidentStatus')
export const Breakfix = i18n.t('analytics.Breakfix')
export const Severity = i18n.t('analytics.Severity')
export const InProg = i18n.t('analytics.InProg')
export const IncidentStatus = i18n.t('analytics.IncidentStatus')
export const Count = i18n.t('analytics.Count')
export const AvgIncidentAgeingResolvedTickets = i18n.t('analytics.AvgIncidentAgeingResolvedTickets')

//SLA Compliance
export const AverageResponseSLAMet = i18n.t('analytics.AverageResponseSLAMet')
export const AverageResolutionSLAMet = i18n.t('analytics.AverageResolutionSLAMet')
export const Trends = i18n.t('analytics.Trends')
export const ResolutionResponseSLA = i18n.t('analytics.ResolutionResponseSLA')
export const TicketSeverity = i18n.t('analytics.TicketSeverity')
export const ResponseSLAMet = i18n.t('analytics.ResponseSLAMet')
export const ResolutionSLAMet = i18n.t('analytics.ResolutionSLAMet')
export const Month = i18n.t('analytics.Month')
export const MetResponseSLA = i18n.t('analytics.MetResponseSLA')
export const ResponseSLAMetPercentage = i18n.t('analytics.ResponseSLAMetPercentage')
export const MetResolutionSLA = i18n.t('analytics.MetResolutionSLA')
export const MetResponseSLAPercentage = i18n.t('analytics.MetResponseSLAPercentage')
export const MetResolutionSLAPercentage = i18n.t('analytics.MetResolutionSLAPercentage')
export const SLAbyFranchise = i18n.t('analytics.SLAbyFranchise')
export const ResolutionAndResponseSLATrend = i18n.t('analytics.ResolutionAndResponseSLATrend')
export const CreatedTimeSLA = i18n.t('analytics.CreatedTimeSLA')
export const AssignedTime = i18n.t('analytics.AssignedTime')
export const ResolvedTime = i18n.t('analytics.ResolvedTime')
export const OnHoldDur = i18n.t('analytics.OnHoldDur')
export const SLAByIncidents = i18n.t('analytics.SLAByIncidents')


//Scheduling Efficiency
export const SchedulingEfficiencySummary = i18n.t('analytics.SchedulingEfficiencySummary')
export const NoOfSchedulerException = i18n.t('analytics.NoOfSchedulerException')
export const TotalNoOfLongRunningAutomatas = i18n.t('analytics.TotalNoOfLongRunningAutomatas')
export const Top10LongRunningAutomatas = i18n.t('analytics.Top10LongRunningAutomatas')
export const ResourcesSchedulingFailuresOccurs = i18n.t('analytics.ResourcesSchedulingFailuresOccurs')
export const CountPercent = i18n.t('analytics.CountPercent')
export const FailurePercent = i18n.t('analytics.FailurePercent')
export const ResourceName = i18n.t('analytics.ResourceName')
export const ExecutionClassificationsOfIncident = i18n.t('analytics.ExecutionClassificationsOfIncident')
export const TotalRuns = i18n.t('analytics.TotalRuns')
export const SchedulerMisses = i18n.t('analytics.SchedulerMisses')
export const ReRuns = i18n.t('analytics.ReRuns')
export const SchedulerEfficiency = i18n.t('analytics.SchedulerEfficiency')
export const SchedulerMissReport = i18n.t('analytics.SchedulerMissReport')
export const ProcessName = i18n.t('analytics.ProcessName')
export const BotId = i18n.t('analytics.BotId')
export const ReasonForSchedulerMiss = i18n.t('analytics.ReasonForSchedulerMiss')
export const DeliveryModel = i18n.t('analytics.DeliveryModel')
export const RequestedBy = i18n.t('analytics.RequestedBy')
export const Reruns = i18n.t('analytics.Reruns')
export const Schmisses = i18n.t('analytics.Schmisses')
export const Component = i18n.t('analytics.Component')

//Queue Management
export const QueueManagementSummary = i18n.t('analytics.QueueManagementSummary')
export const Completed = i18n.t('analytics.Completed')
export const Pending = i18n.t('analytics.Pending')
export const Running = i18n.t('analytics.Running')
export const Exception = i18n.t('analytics.Exception')

//Remediation Dashboard
export const RemediationDashboardSummary = i18n.t('analytics.RemediationDashboardSummary')
export const TotalRuntimeExceptions = i18n.t('analytics.TotalRuntimeExceptions')
export const SuccessfulAttempts = i18n.t('analytics.SuccessfulAttempts')
export const Unqualified = i18n.t('analytics.Unqualified')
export const FailedAttempts = i18n.t('analytics.FailedAttempts')
export const ExceptionVsRemediation = i18n.t('analytics.ExceptionVsRemediation')
export const RemediationAllActivities = i18n.t('analytics.RemediationAllActivities')
export const IncidentNo = i18n.t('analytics.IncidentNo')
export const JobID = i18n.t('analytics.JobID')
export const AssociatedFailureJobID = i18n.t('analytics.AssociatedFailureJobID')
export const Type = i18n.t('analytics.Type')
export const RemediationStatus = i18n.t('analytics.RemediationStatus')
export const DuraMins = i18n.t('analytics.DuraMins')
export const UpdatedOn = i18n.t('analytics.UpdatedOn')
export const RemediationType = i18n.t('analytics.RemediationType')

//Business View
export const Successful = i18n.t('analytics.Successful')
export const Failed = i18n.t('analytics.Failed')
export const ProcessNo = i18n.t('analytics.ProcessNo')
export const QueueTransactions = i18n.t('analytics.QueueTransactions')
export const NonQueueTransactions = i18n.t('analytics.NonQueueTransactions')
export const Trending = i18n.t('analytics.Trending')
export const Processes = i18n.t('analytics.Processes')
export const NoOfExecutions = i18n.t('analytics.NoOfExecutions')
export const BusinessEntityTransactionsSummary = i18n.t('analytics.BusinessEntityTransactionsSummary')
export const BOTID = i18n.t('analytics.BOTID')
export const LeadPlatform = i18n.t('analytics.LeadPlatform')
export const SubArea = i18n.t('analytics.SubArea')
export const SupportStatus = i18n.t('analytics.SupportStatus')
export const BusinessMetric = i18n.t('analytics.BusinessMetric')
export const SystemException = i18n.t('analytics.SystemException')
export const Deferred = i18n.t('analytics.Deferred')
export const ProcessCriticality = i18n.t('analytics.ProcessCriticality')
export const Bizops = i18n.t('analytics.BizOps')


//Alert Management
export const TotalAlerts = i18n.t('analytics.TotalAlerts')
export const UniqueAlerts = i18n.t('analytics.UniqueAlerts')
export const ClientWiseAlertDistribution = i18n.t('analytics.ClientWiseAlertDistribution')
export const Engagement = i18n.t('analytics.Engagement')
export const TicketedAlertsGauge = i18n.t('analytics.TicketedAlertsGauge')
export const GreenAlerts = i18n.t('analytics.GreenAlerts')
export const YellowAlerts = i18n.t('analytics.YellowAlerts')
export const RedAlerts = i18n.t('analytics.RedAlerts')
export const AlertKPI = i18n.t('analytics.AlertKPI')
export const Engage = i18n.t('analytics.Engage')
export const Yellow = i18n.t('analytics.Yellow')
export const Green = i18n.t('analytics.Green')
export const Red = i18n.t('analytics.Red')
export const TicketedAlerts = i18n.t('analytics.TicketedAlerts')
export const DuplicateAlerts = i18n.t('analytics.DuplicateAlerts')
export const InformationalAlerts = i18n.t('analytics.InformationalAlerts')
export const IncidentConversionRatio = i18n.t('analytics.IncidentConversionRatio')
export const EliminatedNoise = i18n.t('analytics.EliminatedNoise')
export const TicketConversionRate = i18n.t('analytics.TicketConversionRate')
export const AvgAlertAnalysisTimeMin = i18n.t('analytics.AvgAlertAnalysisTimeMin')
export const AvgAlertResolutionTimeMin = i18n.t('analytics.AvgAlertResolutionTimeMin')
export const AlertMetric = i18n.t('analytics.AlertMetric')
export const Alert = i18n.t('analytics.Alert')
export const Entity = i18n.t('analytics.Entity')
export const SID = i18n.t('analytics.SID')
export const TicketsCreated = i18n.t('analytics.TicketsCreated')
export const IncidentVelocityTrend = i18n.t('analytics.IncidentVelocityTrend')
export const AlertDistribution = i18n.t('analytics.AlertDistribution')
export const ApplicationAlertMetric = i18n.t('analytics.ApplicationAlertMetric')
export const InfraAlertMetric = i18n.t('analytics.InfraAlertMetric')
export const NoiseReductionforActionable = i18n.t('analytics.NoiseReductionforActionable')
export const GroupedBySID = i18n.t('analytics.GroupedBySID')
export const GroupedByEntity = i18n.t('analytics.GroupedByEntity')
export const GroupedBySourceSID = i18n.t('analytics.GroupedBySourceSID')
export const GroupedBySourceName = i18n.t('analytics.GroupedBySourceName')
export const SourceSID = i18n.t('analytics.SourceSID')
export const SourceName = i18n.t('analytics.SourceName')
export const SourceProvider = i18n.t('manageAutomation.SourceProvider')

//BPMN
export const BusinessActionableSignals = i18n.t('analytics.BusinessActionableSignals')
export const ITActionableSignals = i18n.t('analytics.ITActionableSignals')
export const Signal = i18n.t('analytics.Signal')
export const FaultRadius = i18n.t('analytics.FaultRadius')
export const RecoAction = i18n.t('analytics.RecoAction')
export const RecoveryImpact = i18n.t('analytics.RecoveryImpact')
export const SalesOrdersRevenue = i18n.t('analytics.SalesOrdersRevenue')
export const SalesOrdersIntake = i18n.t('analytics.SalesOrdersIntake')
export const BpmnUser = i18n.t('analytics.BpmnUser')
export const BpmnReport = i18n.t('analytics.BpmnReport')
export const BpmnReportType = i18n.t('analytics.BpmnReportType')
export const BpmnProcessName = i18n.t('analytics.BpmnProcessName')
export const ApplicationAlerts = i18n.t('analytics.ApplicationAlerts')
export const SystemAlerts = i18n.t('analytics.SystemAlerts')
export const Reporting = i18n.t('analytics.Reporting')
export const OrderManagement = i18n.t('analytics.OrderManagement')

//Automation Trust Index
export const AverageSuccessRate = i18n.t('analytics.AverageSuccessRate')
export const Completions = i18n.t('analytics.Completions')
export const Terminations = i18n.t('analytics.Terminations')
export const AutomationTrustIndexSummary = i18n.t('analytics.AutomationTrustIndexSummary')
export const TrustIndexSummary = i18n.t('analytics.TrustIndexSummary')
export const SuccessRate = i18n.t('analytics.SuccessRate')
export const SuccessRateByGeo = i18n.t('analytics.SuccessRateByGeo')
export const SuccessRateFileName = i18n.t('analytics.SuccessRateFileName')
export const BotSummaryReport = i18n.t('analytics.BotSummaryReport')
export const BotSummaryReportFileName = i18n.t('analytics.BotSummaryReportFileName')
export const AutomataStartedOnTime = i18n.t('analytics.AutomataStartedOnTime')
export const StartedOnTime = i18n.t('analytics.StartedOnTime')
export const AutomataRunsOnTime = i18n.t('analytics.AutomataRunsOnTime')
export const RunsOnTime = i18n.t('analytics.RunsOnTime')
export const TotalExecutions = i18n.t('analytics.TotalExecutions')
export const TotalCompletions = i18n.t('analytics.TotalCompletions')
export const SchMisses = i18n.t('analytics.SchMisses')
export const Stopped = i18n.t('analytics.Stopped')
export const SuccessRatePercent = i18n.t('analytics.SuccessRatePercent')
export const Comments = i18n.t('analytics.Comments')
export const ProcessCritical = i18n.t('analytics.ProcessCritical')
export const StartedOnTimePercentage = i18n.t('analytics.StartedOnTimePercentage')
export const RunOnTime = i18n.t('analytics.RunOnTime')
export const RunOnTimePercentage = i18n.t('analytics.RunOnTimePercentage')
export const LastRunStartTime = i18n.t('analytics.LastRunStartTime')
export const RunStatus = i18n.t('analytics.RunStatus')
export const CountOfOpenIncidents = i18n.t('analytics.CountOfOpenIncidents')
export const TotalNoOfBots = i18n.t('analytics.TotalNoOfBots')

//Productivity Metrics
export const SavedHours = i18n.t('analytics.SavedHours')
export const NumberOfResources = i18n.t('analytics.NumberOfResources')
export const ResourceUtilization = i18n.t('analytics.ResourceUtilization')
export const OnboardedBots = i18n.t('analytics.OnboardedBots')
export const CriticalResolutionTime = i18n.t('analytics.CriticalResolutionTime')
export const NormalResolutionTime = i18n.t('analytics.NormalResolutionTime')
export const CriticalResponseTime = i18n.t('analytics.CriticalResponseTime')
export const NormalResponseTime = i18n.t('analytics.NormalResponseTime')
export const Successrate = i18n.t('analytics.Successrate')
export const AutomataRunsOnTimeMetrics = i18n.t('analytics.AutomataRunsOnTimeMetrics')
export const AutomataStartsOnTimeMetrics = i18n.t('analytics.AutomataStartsOnTimeMetrics')
export const ResolutionTime = i18n.t('analytics.ResolutionTime')
export const CriticalP1P2 = i18n.t('analytics.CriticalP1P2')
export const CriticalTargetPercentage = i18n.t('analytics.CriticalTargetPercentage')
export const NormalP3P4 = i18n.t('analytics.NormalP3P4')
export const NormalTargetPercentage = i18n.t('analytics.NormalTargetPercentage')
export const ResponseTime = i18n.t('analytics.ResponseTime')
export const SuccessRateMetrics = i18n.t('analytics.SuccessRateMetrics')
export const Percentage = i18n.t('analytics.Percentage')
export const AutomataStartsOnTime = i18n.t('analytics.AutomataStartsOnTime')
export const CriticalP1 = i18n.t('analytics.CriticalP1')
export const NormalP2P3P4 = i18n.t('analytics.NormalP2P3P4')

//Capacity Management
export const NoOfResources = i18n.t('analytics.NoOfResources')
export const AverageUtilization = i18n.t('analytics.AverageUtilization')
export const BotsExceedingUtilization = i18n.t('analytics.BotsExceedingUtilization')
export const CapacityManagementSummary = i18n.t('analytics.CapacityManagementSummary')
export const ResourceUtilizationReport = i18n.t('analytics.ResourceUtilizationReport')
export const ResourceUtilizationFileName = i18n.t('analytics.ResourceUtilizationFileName')
export const AutomataOnboardingReport = i18n.t('analytics.AutomataOnboardingReport')
export const AutomataOnBoardingReportFileName = i18n.t('analytics.AutomataOnBoardingReportFileName')
export const SwitchToPeakUtilization = i18n.t('analytics.SwitchToPeakUtilization')
export const SwitchToAverageUtilization = i18n.t('analytics.SwitchToAverageUtilization')
export const SelectDays = i18n.t('analytics.SelectDays')
export const ExcludeDays = i18n.t('analytics.ExcludeDays')
export const ExcludeSeconds = i18n.t('analytics.ExcludeSeconds')
export const Eg90 = i18n.t('analytics.Eg90')
export const Resources = i18n.t('analytics.Resources')
export const ChangeResources = i18n.t('analytics.ChangeResources')
export const Utilization = i18n.t('analytics.Utilization')
export const Hours = i18n.t('analytics.Hours')
export const Kantar = i18n.t('analytics.Kantar')
export const UtilizationHeader = i18n.t('analytics.UtilizationHeader')
export const AutomataNames = i18n.t('analytics.AutomataNames')
export const OnboardingDate = i18n.t('analytics.OnboardingDate')
export const OffboardingDate = i18n.t('analytics.OffboardingDate')
export const Executions = i18n.t('analytics.Executions')
export const PeakUtilization = i18n.t('analytics.PeakUtilization')
export const CurevMonotonex = i18n.t('analytics.CurevMonotonex')
export const CurveSStepAfter = i18n.t('analytics.CurveSStepAfter')
export const HourView = i18n.t('analytics.HourView')
export const DayView = i18n.t('analytics.DayView')
export const DateView = i18n.t('analytics.DateView')
export const TimeIntervals = i18n.t('analytics.TimeIntervals')

//Queue Performance
export const AutomataAccuracyReport = i18n.t('analytics.AutomataAccuracyReport')
export const QueuePerformance = i18n.t('analytics.QueuePerformance')
export const NoOfItems = i18n.t('analytics.NoOfItems')
export const BusinessEx = i18n.t('analytics.BusinessEx')
export const SystemEx = i18n.t('analytics.SystemEx')
export const AutomataAccuracy = i18n.t('analytics.AutomataAccuracy')
export const AverageRetries = i18n.t('analytics.AverageRetries')
export const AvgHandlingTimeMin = i18n.t('analytics.AvgHandlingTimeMin')
export const AvgProcessingTimeMin = i18n.t('analytics.AvgProcessingTimeMin')
export const dFTE = i18n.t('analytics.dFTE')
export const Speed = i18n.t('analytics.Speed')
export const UPT = i18n.t('analytics.UPT')
export const Others = i18n.t('analytics.Others')
export const NoOfProcess = i18n.t('analytics.NoOfProcess')

//Execution Performance
export const ExecutionPerformanceSummary = i18n.t('analytics.ExecutionPerformanceSummary')
export const TerminationRate = i18n.t('analytics.TerminationRate')
export const TerminationRateTrend = i18n.t('analytics.TerminationRateTrend')
export const TerminationRatepercent = i18n.t('analytics.TerminationRatepercent')
export const ExeStatistics = i18n.t('analytics.ExeStatistics')
export const ExeClassifications = i18n.t('analytics.ExeClassifications')
export const HistoricalActivityMetrics = i18n.t('analytics.HistoricalActivityMetrics')
export const TopTerminationsReasons = i18n.t('analytics.TopTerminationsReasons')
export const Reasons = i18n.t('analytics.Reasons')
export const Weekly = i18n.t('analytics.Weekly')
export const Exceptions = i18n.t('analytics.Exceptions')
export const TerminationsPercentage = i18n.t('analytics.TerminationsPercentage')
export const RepeatedTerminationBots = i18n.t('analytics.RepeatedTerminationBots')
export const GeoName = i18n.t('analytics.GeoName')
export const Criticality = i18n.t('analytics.Criticality')
export const RepeatedTerminations = i18n.t('analytics.RepeatedTerminations')
export const ScheduleFrequency = i18n.t('analytics.ScheduleFrequency')
export const LastExecutionTime = i18n.t('analytics.LastExecutionTime')

//JuniperDashboard
export const Tickets = i18n.t('analytics.Tickets')
export const YetToBeProcessed = i18n.t('analytics.YetToBeProcessed')
export const ProcessedWithPrediction = i18n.t('analytics.ProcessedWithPrediction')
export const ProcessedWithChange = i18n.t('analytics.ProcessedWithChange')
export const ServiceDeskTriageSummary = i18n.t('analytics.ServiceDeskTriageSummary')
export const Report = i18n.t('analytics.Report')
export const IncidentId = i18n.t('analytics.IncidentId')
export const Summary = i18n.t('analytics.Summary')
export const Description = i18n.t('analytics.Description')
export const TicketType = i18n.t('analytics.TicketType')
export const RootCause = i18n.t('analytics.RootCause')
export const Category = i18n.t('analytics.Category')
export const AssignmentGroup = i18n.t('analytics.AssignmentGroup')
export const CreatedDate = i18n.t('analytics.CreatedDate')
export const CreatedTime = i18n.t('analytics.CreatedTime')
export const ActionedbySME = i18n.t('analytics.ActionedbySME')
export const ChangedResolutionSteps = i18n.t('analytics.ChangedResolutionSteps')
export const ChangedRootCause = i18n.t('analytics.ChangedRootCause')
export const ChangedAssignmentGroup = i18n.t('analytics.ChangedAssignmentGroup')
export const PredictionReport = i18n.t('analytics.PredictionReport')
export const SnowCategory = i18n.t('analytics.SnowCategory')
export const SnowAssignmentGroup = i18n.t('analytics.SnowAssignmentGroup')
export const PredictedCategory = i18n.t('analytics.PredictedCategory')
export const PredictedAssignmentGroup = i18n.t('analytics.PredictedAssignmentGroup')
export const MatchCategory = i18n.t('analytics.MatchCategory')
export const MatchAssignmentGroup = i18n.t('analytics.MatchAssignmentGroup')
export const ClosureDate = i18n.t('analytics.ClosureDate')


//Bot Performance
export const RobotTerminationTrend = i18n.t('analytics.RobotTerminationTrend')
export const TerminationsPercent = i18n.t('analytics.TerminationsPercent')
export const RobotPerformanceSummary = i18n.t('analytics.RobotPerformanceSummary')
export const BotPerformanceFileName = i18n.t('analytics.BotPerformanceFileName')
export const PreviousPage = i18n.t('analytics.PreviousPage')
export const ProcessNumber = i18n.t('analytics.ProcessNumber')
export const TerminationsRate = i18n.t('analytics.TerminationsRate')
export const FirstTimeRun = i18n.t('analytics.FirstTimeRun')
export const botID = i18n.t('analytics.botID')
export const totalRuns = i18n.t('analytics.totalRuns')
export const totalSuccess = i18n.t('analytics.totalSuccess')
export const SuccessOn1stRun = i18n.t('analytics.SuccessOn1stRun')
export const FirstRunSuccessPercent = i18n.t('analytics.FirstRunSuccessPercent')

//Bpmn
export const ProcessSteps = i18n.t('analytics.ProcessSteps');
export const PerfectOrderfullfillment = i18n.t('analytics.PerfectOrderfullfillment');
export const InvoiceCyclePeriod = i18n.t('analytics.InvoiceCyclePeriod');
export const DefectRate = i18n.t('analytics.DefectRate');
export const OrderToCash = i18n.t('analytics.OrderToCash');
export const OrderToCashV1 = i18n.t('analytics.OrderToCashV1');
export const BusinessAnomalies = i18n.t('analytics.BusinessAnomalies');
export const AlertName = i18n.t('analytics.AlertName');
export const ImpactedKPI = i18n.t('analytics.ImpactedKPI');
export const Impact = i18n.t('analytics.Impact');
export const IncNo = i18n.t('analytics.IncNo');
export const ITAnomalies = i18n.t('analytics.ITAnomalies');
export const BPMNStatus = i18n.t('analytics.BPMNStatus');
export const SalesDocumentProcess = i18n.t('analytics.SalesDocumentProcess');
export const AddKpi = i18n.t('analytics.AddKpi');
export const Actual = i18n.t('analytics.Actual');
export const SinceYesterday = i18n.t('analytics.SinceYesterday');
export const Alerts = i18n.t('manageAutomation.Alerts');
export const Items = i18n.t('manageAutomation.Items');
export const Details = i18n.t('manageAutomation.Details');
export const QueryPrompts = i18n.t('analytics.QueryPrompts');

//Automation Business
export const AutomationBusinessCatalogue = i18n.t('analytics.AutomationBusinessCatalogue');
export const LoadingChart = i18n.t('analytics.LoadingChart');
export const successrate = i18n.t('analytics.successrate');
export const Terminationrate = i18n.t('analytics.Terminationrate');
export const CapacityUtilization = i18n.t('analytics.CapacityUtilization');
export const ROI = i18n.t('analytics.ROI');
export const SelfHealRate = i18n.t('analytics.SelfHealRate');
export const name = i18n.t('analytics.name');
export const Name = i18n.t('analytics.Name');
export const value = i18n.t('analytics.value');
export const tag = i18n.t('analytics.tag');

//Queue & Resource Alerts
export const QueueStatus = i18n.t('manageAutomation.QueueStatus');
export const ResourceStatus = i18n.t('manageAutomation.ResourceStatus');
export const TotalItem = i18n.t('manageAutomation.TotalItem');
export const RecentItemProcessedAt = i18n.t('manageAutomation.RecentItemProcessedAt');
export const TimespanSinceLastItemProcessed = i18n.t('manageAutomation.TimespanSinceLastItemProcessed');
export const Offline = i18n.t('manageAutomation.Offline');
export const Missing = i18n.t('manageAutomation.Missing');
export const LoggedOut = i18n.t('manageAutomation.LoggedOut');
export const Available = i18n.t('manageAutomation.Available');
export const Busy = i18n.t('manageAutomation.Busy');
export const Private = i18n.t('manageAutomation.Private');
export const All = i18n.t('manageAutomation.All');
// export const AssignedTo = i18n.t('manageAutomation.AssignedTo');
export const ResourcePoolName = i18n.t('manageAutomation.ResourcePoolName');
export const RecentCurrentActiveProcess = i18n.t('manageAutomation.RecentCurrentActiveProcess');
export const TimeSpanSinceRecentExecution = i18n.t('manageAutomation.TimeSpanSinceRecentExecution');
export const NoOfSimilarIssues = i18n.t('manageAutomation.NoOfSimilarIssues');
export const LastStatusChange = i18n.t('manageAutomation.LastStatusChange');

//UserLogin Statistics
export const TotalUserStats = i18n.t('analytics.TotalUserStats');
export const SuccessfulUserStats = i18n.t('analytics.SuccessfulUserStats');
export const Failures = i18n.t('analytics.Failures');
export const RecurringFailures = i18n.t('analytics.RecurringFailures');
export const LongRunningSessions = i18n.t('analytics.LongRunningSessions');
export const LoginTrend = i18n.t('analytics.LoginTrend');
export const TopFailureReasons = i18n.t('analytics.TopFailureReasons');
export const EventStatistics = i18n.t('analytics.EventStatistics');
export const TopFailureSources = i18n.t('analytics.TopFailureSources');
export const Sources = i18n.t('analytics.Sources');

//Batch Jobs Statistics
export const BatchJobTrend = i18n.t('analytics.BatchJobTrend');

//Integration Statistics
export const IntegrationTrend = i18n.t('analytics.IntegrationTrend');

//Abandoned Processes Trend
export const AbandonedProcessesTrend = i18n.t('analytics.AbandonedProcessesTrend')

//Usage Stats
export const GeoHeatmap = i18n.t('analytics.GeoHeatmap');
export const TotalUniqueVisitors = i18n.t('analytics.TotalUniqueVisitors');
export const TotalSessions = i18n.t('analytics.TotalSessions');
export const AverageDuration = i18n.t('analytics.AverageDuration');
export const Username = i18n.t('analytics.Username');
export const LoggedInAt = i18n.t('analytics.LoggedInAt');
export const LoggedOutAt = i18n.t('analytics.LoggedOutAt');
export const Duration = i18n.t('analytics.Duration');
export const Activity = i18n.t('analytics.Activity');
export const Geos = i18n.t('analytics.Geos');
export const UniqueUsers = i18n.t('analytics.UniqueUsers');
export const UniqueVisitors = i18n.t('analytics.UniqueVisitors');

//Processes

export const ProcessesSummary = i18n.t('analytics.ProcessesSummary');
export const OrderId = i18n.t('analytics.OrderId');
export const OrderNumber = i18n.t('analytics.OrderNumber');
export const Error = i18n.t('analytics.Error');
export const IncidentNumber = i18n.t('analytics.IncidentNumber');
export const AssignedTo = i18n.t('analytics.AssignedTo');
export const ProcessingTrend = i18n.t('analytics.ProcessingTrend');
export const AutomationDowntime = i18n.t('analytics.AutomationDowntime');
export const Orders = i18n.t('analytics.Orders');
export const HumanError = i18n.t('analytics.HumanError');
export const MachineError = i18n.t('analytics.MachineError');
export const Mins = i18n.t('analytics.Mins');
export const HoursLabel = i18n.t('analytics.HoursLabel');
export const Anomalies = i18n.t('analytics.Anomalies');
export const ExpectedTimeOfCompletion = i18n.t('analytics.ExpectedTimeOfCompletion');
export const Received = i18n.t('analytics.Received');
export const Average = i18n.t('analytics.Average');
export const ProcessingTime = i18n.t('analytics.ProcessingTime');

//Billing Report

export const Home = i18n.t('billingReport.Home');
export const billingTitle = i18n.t('billingReport.Title');
export const BillingDescription = i18n.t('billingReport.TitleDescription');
export const AllClients = i18n.t('billingReport.AllClients');
export const Months = i18n.t('billingReport.Months');
export const ChooseOption = i18n.t('billingReport.ChooseOption');
export const whatAreYouLookingForToday = i18n.t('billingReport.whatAreYouLookingForToday');
export const ClientName = i18n.t('billingReport.ClientName');
export const ProjectID = i18n.t('billingReport.ProjectID');
export const AccountID = i18n.t('billingReport.AccountID');
export const BillingPeriod = i18n.t('billingReport.BillingPeriod');
export const BillingMonth = i18n.t('billingReport.BillingMonth');
export const DateOfIssue = i18n.t('billingReport.DateOfIssue');
export const InvoiceAmount = i18n.t('billingReport.InvoiceAmount');
export const AccountName = i18n.t('billingReport.AccountName');
export const CnumID = i18n.t('billingReport.CnumID');
export const AlertVolumeOfCurrentBillingPeriod = i18n.t('billingReport.AlertVolumeOfCurrentBillingPeriod');
export const AlertVolumeOfLastBillingPeriod = i18n.t('billingReport.AlertVolumeOfLastBillingPeriod');
export const CostIncurredDate = i18n.t('billingReport.CostIncurredDate');
export const AdjustmentForLastMonth = i18n.t('billingReport.AdjustmentForLastMonth');
export const FinalAmount = i18n.t('billingReport.FinalAmount');
export const Remarks = i18n.t('billingReport.Remarks');
export const MonthlyBillingReport = i18n.t('billingReport.MonthlyBillingReport');
export const BillingReport = i18n.t('billingReport.BillingReport');



